import { apiConstants } from '../../apiConstant'
import { serviceCall, serviceCallAuth } from '../../serviceCall'

export const getHomeAreaListApi = (data, callback, errorCallBack) => {
    return async (dispatch) => {
        serviceCall({
            url: apiConstants.HOME_MAINTENANCE.GET_HOME_AREA_LIST,
            method: 'get',
            data: data,
        })
            .then((response) => {
                callback && callback(response.data)
            })
            .catch((error) => {
                errorCallBack && errorCallBack(error.response)
            })
    }
}
